import { settingsAPI } from './api';
import createTenantCache from './createTenantCache';
import { displayName } from '../utils/displayName';

/**
 * tenantUserNames — the tenant's users' current display names, keyed by
 * Cognito sub (and username id), for resolving note authors (IDI-550).
 *
 * Fetched from list_users&scope=tenant once per session; scoped to the
 * signed-in tenant and cleared on logout / tenant change (IDI-304, via
 * createTenantCache → registerTenantReset). A failed fetch yields an empty
 * map and is not retried this session — NotesPanel then shows the stored
 * author.
 */
function buildNamesBySub(users) {
  const map = {};
  (Array.isArray(users) ? users : []).forEach((u) => {
    if (!u) return;
    const name = displayName(u);
    if (!name) return;
    if (u.sub) map[u.sub] = name;
    if (u.id && !map[u.id]) map[u.id] = name;
  });
  return map;
}

const cache = createTenantCache(
  () => settingsAPI.getTenantUsers().then(buildNamesBySub),
  { label: 'tenantUserNames' }
);

/** Hook: `{ [sub]: name }` (empty until loaded or on failure). */
export function useTenantUserNames() {
  const { value } = cache.useCached();
  return value || {};
}

/** Test-only escape hatch. */
export function __resetTenantUserNames() {
  cache.reset();
  cache.__clearSubscribers();
}
